import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { FormProperties, useFormProperties } from "./FormProperties";

import { DraftFormComponent } from "./DraftFormComponent";
import { FC } from "react";
import { FormContext } from "./FormContext";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

export const FormComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useFormProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties)
        return <></>

    return (<FormContext {...properties} className={className}>
        {children}
    </FormContext>)
}

Registry.addControl({
    id: "f5e8a323-d69a-4240-8851-146ee67050a2",
    name: "Form",
    type: ControlType.Form,
    properties: FormProperties,
    component: FormComponent,
    draftComponent: DraftFormComponent
})
